import type { ProductGroupsFiltersType } from '@components/catalog/productGroup/grid/ProductGroupsFilter'

import { makeFilter } from './crud/filters'


export const prepareProductGroupsFilter = (filters: ProductGroupsFiltersType) => {
  const idsFilter = makeFilter('id', 'contains', filters.ids)
  const nameFilter = makeFilter('name', 'starts_with', filters.name)
  const labelFilter = makeFilter('label', 'starts_with', filters.label)
  const typeFilter = makeFilter('type', 'eq', filters.type)

  return {
    and: [
      idsFilter,
      nameFilter,
      labelFilter,
      typeFilter
    ]
  }
}